<template>
	<button class="hqyzm" :disabled='disabled' @click="getCode" v-text="btnText"></button>
</template>
<script>
import {checkedPhone} from "../util/login";  //手机号码 密码验证
export default {
    data() {
        return {
            time:60,
            disabled:false,
            btnText:'获取验证码',
            isDisabled1:true
        };
    },
    props:['phone',"isLogin",'isRegister'],
    methods: {
       //获取验证码
        getCode(){
            var type='';
            if(this.isLogin){
                type=1;
            }else if(this.isRegister){
                type=2;
            }
            if (this.isDisabled1&&document.getElementsByClassName('el-message').length === 0) {
                this.isDisabled1=false;
                var  phone=this.phone;
                if(checkedPhone(this,phone)){  //判断手机号码
                    if(this.isLogin||this.isRegister){
                        this.post(this, "/home/login/phone", {phone,type}).then(res => {
                            if(res.data.code==0){
                                this.getCodeFun(phone);
                            }else{
                                this.isDisabled1=true;
                            }
                        })
                    }else{
                        this.getCodeFun(phone);
                    }
                }else{
                    this.isDisabled1=true;
                }
            }
        },
        getCodeFun(phone){
            this.post(this, "/common/send/smsCode", {phone}).then(res => {
                if(res.data.code == 0) {
                    this.$message.success(res.data.msg);
                    this.time=60;
                    this.timer();
                }
                this.isDisabled1=true;
            });
        },
        timer() {
            if (this.time > 1) {
                this.disabled=true;
                this.time--;
                this.btnText=this.time+'秒';
                setTimeout(this.timer, 1000);
            } else{
                this.btnText='获取验证码';
                this.disabled=false;
            }
        },
    },
};
</script>
<style scoped>
	.hqyzm{
		height: 40px;
		width: 115px;
		color: #fff;
		outline: 0;
		border-radius: 2px;
		background: #ff7b00;
		position: absolute;
		right: 0;
		top: 15px;
        cursor: pointer;
	}
    .hqyzm:disabled{ 
        background-color: #999;
    }
</style>
